module.exports = __webpack_public_path__ + "img/beach.bb20a9d8.png";